/* eslint-disable no-underscore-dangle */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Hint from './Hint';
import './ListItemDrawer.sass';

class ListItemDrawer extends Component {
  constructor(props) {
    super(props);
    this.state = { __show__: props.defaultShow };
    this.handleDrawerClick = this.handleDrawerClick.bind(this);
  }

  handleDrawerClick(event) {
    this.setState({ __show__: !this.state.__show__ });

    /* Invoke the onClick function */
    this.props.onClick(event);
  }

  render() {
    let { show } = this.props;
    const { hintConfig } = this.props;
    const {
      title,
      hint,
      children,
      className
    } = this.props;
    const { __show__ } = this.state;

    /* The outer property show will override the inner state */
    if (show === null) { show = __show__; }

    return (
      <div className="ListItemDrawer">
        <h3 onClick={this.handleDrawerClick}>
          {title}
          {hint ? <Hint {...hintConfig}>{hint}</Hint> : undefined}
        </h3>
        <span className={`fa fa-angle-down ${show ? 'show' : ''}`} />
        <div className={`content ${show ? 'show' : ''} ${className}`}>{children}</div>
      </div>
    );
  }
}

ListItemDrawer.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.any.isRequired,
  title: PropTypes.string.isRequired,
  hint: PropTypes.any,
  hintConfig: PropTypes.object,
  className: PropTypes.string,
  show: PropTypes.bool,
  defaultShow: PropTypes.bool
};

ListItemDrawer.defaultProps = {
  onClick() { },
  hint: 'This is hint...',
  hintConfig: {},
  className: '',
  show: null,
  defaultShow: false
};

export default ListItemDrawer;



// WEBPACK FOOTER //
// ./src/components/ListItemDrawer.jsx